export default {"src":"/_next/static/media/ship-camps-dark.54543c0b.svg","height":50,"width":112,"blurWidth":0,"blurHeight":0};